import React, { createContext, useContext, ReactNode, useMemo } from 'react'
import { ComponentConfig } from '@/types'
import {
  getLocaleResource,
  DEFAULT_LOCALE,
  type TranslationKeys,
  type SupportedLocale,
  isSupportedLocale,
} from '@/locales'

interface ComponentProviderProps {
  config: ComponentConfig
  children: ReactNode
}

interface ComponentContextValue extends ComponentConfig {
  translations: TranslationKeys
  currentLocale: SupportedLocale
}

const ComponentContext = createContext<ComponentContextValue | null>(null)

export const ComponentProvider: React.FC<ComponentProviderProps> = ({
  config,
  children,
}) => {
  const contextValue = useMemo(() => {
    // 确定当前语言
    const locale = config.locale || DEFAULT_LOCALE
    const currentLocale = isSupportedLocale(locale) ? locale : DEFAULT_LOCALE

    // 获取对应的翻译资源
    const translations = getLocaleResource(currentLocale)

    return {
      ...config,
      currentLocale,
      translations,
    }
  }, [config])

  return (
    <ComponentContext.Provider value={contextValue}>
      {children}
    </ComponentContext.Provider>
  )
}

export const useComponentConfig = () => {
  const context = useContext(ComponentContext)
  if (!context) {
    throw new Error('useComponentConfig must be used within ComponentProvider')
  }
  return context
}
